// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"book-health-check-modal_modalContainer--x_zT4cmh","green":"book-health-check-modal_green--JRUCAflS","headerLarge":"book-health-check-modal_headerLarge--1Ks7ofcs","body":"book-health-check-modal_body--2j_M8Boz","authentication":"book-health-check-modal_authentication--2xSzkB-W","details":"book-health-check-modal_details--AKjwu_fw","successScreen":"book-health-check-modal_successScreen--3i2g4lVr"};


//////////////////
// WEBPACK FOOTER
// ./components/doctify-modals/src/styles/book-health-check-modal.scss
// module id = 1660
// module chunks = 0